import AxiosInitializer from 'api/Utility/AxiosInitializer'
import { handleStatus500 } from 'api/Utility/HandleStatus500'
import apiWrapper from 'api/Utility/ApiWrapper'
import apiHeaders from 'api/Utility/ApiHeaders'
import getToken from 'lib/authentication/GetToken'
import { getBaseURL } from 'lib/utility/GetBaseUrl'
import { handleLoginPageRedirection } from 'lib/authentication/Logout'

const { noBearerToken, getBearerToken } = apiHeaders

const axiosCommonReq = (extraParams: any = {}) => {
  const params = {
    ...extraParams,
  }

  return AxiosInitializer({
    ...params,
  })
}

const GetUserURL = `/users/current`

const userEndPoints = {
  fetchLocaleData: (params = {}) => {
    return axiosCommonReq({
      transformResConfig: false,
      token: getToken(),
    }).patch('/users/update_locale', {
      data: params,
    })
  },
  fetchUserTokens: (params = {}) => {
    return axiosCommonReq({
      transformResConfig: false,
    }).post(
      '/tokens',
      {
        data: params,
      },
      {
        headers: {
          ...noBearerToken(),
        },
      },
    )
  },
  getUser: () => {
    return axiosCommonReq({
      transformResConfig: true,
      token: getToken(),
    }).get(GetUserURL)
  },
  logout: () => {
    return axiosCommonReq().delete('admin/api/auth/logout', {
      baseURL: getBaseURL(),
      headers: {
        ...getBearerToken(),
      },
    })
  },
}

const { fetchLocaleData, fetchUserTokens, logout } = userEndPoints

const userApis = {
  fetchLocaleData: (params: any) => {
    return apiWrapper({
      endPoint: fetchLocaleData,
      params,
      errorFailureAction: handleStatus500,
    })
  },
  fetchUserTokens: (params: any) => {
    return apiWrapper({
      endPoint: fetchUserTokens,
      params,
      errorFailureAction: handleStatus500,
    })
  },
  getUser: (params = {}) =>
    apiWrapper({
      endPoint: userEndPoints.getUser,
      params,
      errorFailureAction: handleLoginPageRedirection,
    }),
  logout: () => {
    return apiWrapper({
      endPoint: logout,
      errorFailureAction: handleStatus500,
    })
  },
}

export default userApis
